<template>
   <ul :class="listClasses" :id="id">
       <li v-for="item in enabledItems" :key="item.id" :class="item.active">
          <router-link v-if="item.full_path && item.isLink" :to="item.full_path"><i :class="'fa-li fal fa-fw fa-'+item.icon"></i><span v-html="item.title" /></router-link>
          <a v-else :href="item.url || '#'+item.id" :class="item.classes" v-b-toggle="item.id+'-collapse'" :data-toggle="item['data-toggle']"><i :class="'fa-li fal fa-fw fa-'+item.icon"></i><span v-html="item.title" /></a>
          <b-collapse :id="item.id+'-collapse'">
            <MenuItems v-if="item.items" :items="item.items" :id="item.id"/>
          </b-collapse>
       </li>
   </ul>
</template>

<script>
   export default {
       props: {
         items:{
            type: Array,
            required: true,
         },
         id:{
            type: String,
            required: true,
         },
         top:{
            type: Boolean,
            required: false,
         },
       },
      computed: {
          listClasses: function () { return 'fa-ul '+(this.top ? 'on-screen-menu desktop-only-not mr-auto mt-2 mt-lg-0' :'') },
          enabledItems: function () { return this.items.filter(item => item.enabled).map(item => Object.assign({}, item, {
              classes: [this.top && 'top-level', item.items && 'has-submenu', !item.items && item.url && 'collapsed'].filter(a => a).join(' '),
              isLink: item.isLink!==false
          }, item.items && { 'data-toggle': 'collapse' })) }
      },
      created() {
      }
   }
</script>

<style>
</style>
